/*  MUI  */
import { DialogContent } from '@mui/material';

/*  React  */
import React from 'react';

export const ModalBody = ({ children, ...rest }) => (
    <DialogContent style={{ padding: '24px' }} {...rest}>
        {children}
    </DialogContent>
);
